import { getJsNow } from 'utils/date';
import * as dueDateHelpers from 'resources/milestone/dueDate.helpers';
import * as dealHelpers from 'resources/deal/deal.helpers';
import { DEAL_STAGES } from 'resources/deal/deal.constants';
import { AUDIT_COMPLETED_STATUSES } from './audit.constants';
import { AUDIT_TYPES } from './audit.constants';
import { DateTime } from 'luxon-business-days';


export const isCompleted = (audit) => Object.values(AUDIT_COMPLETED_STATUSES).includes(audit?.status);

export const isCompletedSuccess = (audit) => audit?.status === AUDIT_COMPLETED_STATUSES.COMPLETED_SUCCESS;

export const isCompletedWithErrors = (audit) => audit?.status === AUDIT_COMPLETED_STATUSES.COMPLETED_ERRORS;

export const isAnyAuditDueTodayOrEarlier = ({ audits, deal }) => {
  if (!audits)
    return false;

  const luxonToday = DateTime.now().startOf('day'); // get date only part

  return audits.some((audit) => {
    // check if audit is non-completed OR completed with errors
    const isRelevantAudit = !isCompleted(audit) || isCompletedWithErrors(audit);
    if (!isRelevantAudit) return false;

    // check if due date is today or earlier
    const luxonDueDate = dueDateHelpers.getDealAuditDueDate({ audit, deal });
    return luxonDueDate.toMillis() <= luxonToday.toMillis();
  });
};

export const DEAL_STAGE_TO_AUDIT_TYPE = {
  [DEAL_STAGES.PRE_CONTRACT]: AUDIT_TYPES.PRE_CONTRACT,
  [DEAL_STAGES.PRE_CONTRACT_ACTIVE_LISTING]: AUDIT_TYPES.PRE_CONTRACT,
  [DEAL_STAGES.PRE_CONTRACT_HOME_SEARCH]: AUDIT_TYPES.PRE_CONTRACT,
  [DEAL_STAGES.PRE_CONTRACT_MAKE_OFFER]: AUDIT_TYPES.PRE_CONTRACT,
  [DEAL_STAGES.UNDER_CONTRACT]: AUDIT_TYPES.UNDER_CONTRACT,
};
